import type { ReactNode } from "react";

import { Card, CardContent } from "@runcheetah/ui";

export function BillingCard({
  children,
  className,
  contentClassName,
}: {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}) {
  return (
    <Card className={className ?? "overflow-hidden border-border/70 bg-card/95 shadow-sm"}>
      <CardContent className={contentClassName ?? "p-5 sm:p-6"}>{children}</CardContent>
    </Card>
  );
}
